import { useEffect, useState } from "react";
import { images } from "../data/portfolioData";

const slides = [
  { id: "stage", src: images.stage, tag: "STAGE // KEYNOTE", alt: "Armand speaking on a technology stage", caption: "Make the complex memorable." },
  { id: "seated", src: images.seated, tag: "SESSION // DISCOVERY", alt: "Armand listening at a technology event", caption: "Listen first. Design second." },
  { id: "simulator", src: images.simulator, tag: "CRAFT // SIMULATION", alt: "Armand driving a racing simulator", caption: "Focus is a form of play." },
  { id: "community", src: images.community, tag: "COMMUNITY // EXCHANGE", alt: "Armand taking part in a community presentation event", caption: "Ideas get stronger in conversation." },
];

function PhotoReel() {
  const [index, setIndex] = useState(0);
  const [playing, setPlaying] = useState(true);

  useEffect(() => {
    if (!playing) return undefined;
    const timer = window.setInterval(() => setIndex((value) => (value + 1) % slides.length), 4200);
    return () => window.clearInterval(timer);
  }, [playing]);

  const slide = slides[index];
  return (
    <section id="reel" className="chapter reel-section" data-section="reel" data-testid="speaking-reel-section">
      <div className="chapter-intro">
        <div className="section-kicker"><span>04</span><span>THE ROOM / IN MOTION</span></div>
        <div><h2 data-testid="speaking-reel-heading">Ideas have a physical presence.</h2><p className="chapter-lead">A four-frame photo reel for the stage, the room, and the interests that keep the work human.</p></div>
      </div>
      <div className="reel-layout">
        <figure className="reel-frame"><img key={slide.src} src={slide.src} alt={slide.alt} data-testid="speaking-reel-image" /><figcaption>{slide.caption}</figcaption><span className="reel-frame-label">{slide.tag}</span></figure>
        <div className="reel-copy"><div className="reel-index" data-testid="speaking-reel-index-indicator">0{index + 1} / 0{slides.length}</div><p>Technical storytelling is not a performance layered on top of the work. It is part of the work: give the room a shape, a signal, and a reason to move.</p><button className="reel-toggle" type="button" onClick={() => setPlaying((value) => !value)} data-testid="speaking-reel-toggle">{playing ? "Pause reel" : "Play reel"}<span>{playing ? "Ⅱ" : "▶"}</span></button><div className="reel-tabs" aria-label="Choose reel frame">{slides.map((item, itemIndex) => <button key={item.id} className={index === itemIndex ? "is-active" : ""} type="button" aria-label={`Show ${item.tag.toLowerCase()}`} aria-pressed={index === itemIndex} onClick={() => { setIndex(itemIndex); setPlaying(false); }} data-testid={`speaking-reel-tab-${itemIndex}`}>0{itemIndex + 1}</button>)}</div><span className="reel-note">STAGE / DISCOVERY / PERSONAL CRAFT</span></div>
      </div>
    </section>
  );
}

export default PhotoReel;
